import { FC, ReactNode } from 'react';

type Props = {
    children: ReactNode;
};

const PrivacyPolicyCheckboxWrapper: FC<Props> = ({ children }) => {
    return (
        <div className="tw-flex tw-flex-col">
            <div className={'tw-font-graphik-medium tw-text-sm'}>
                By submitting this form, you acknowledge that your information will be processed according to{' '}
                <a href="/privacy-notice/" className={'!tw-text-sm !tw-text-navy-600 hover:!tw-text-[teal]'}>
                    TouchBistro Privacy Notice
                </a>
                .
            </div>
            <div className="tw-mt-2">{children}</div>
        </div>
    );
};

export default PrivacyPolicyCheckboxWrapper;
